<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      {{squadUuid ? $t('editTeam') : $t('addTeam') }}
    </template>
    <div v-show="!loading" class="form_wrap">
      <vue-scroll>
        <el-form
          ref="squadForm"
          :model="squadInfo"
          :rules="formRules"
          label-width="100px"
          class="black_form">
          <el-row>
            <el-col :span="11">
              <el-form-item label-width="1.2rem" :label="$t('teamName')" prop="squadName">
                <el-select
                  v-model="squadInfo.squadName"
                  :placeholder="$t('teamPlaceholder')"
                  clearable
                  style="width:100%"
                >
                  <el-option
                    v-for="item in squadNameList"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label-width="1.2rem" :label="$t('shortName')">
                <el-input
                  v-model.trim="squadInfo.shortName"
                  :placeholder="$t('shortNamePlaceholder')"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item :label="$t('leaderName')" label-width="1.2rem" prop="leaderUuid">
                <el-select
                  v-model="squadInfo.leaderUuid"
                  :placeholder="$t('leaderPlaceholder')"
                  clearable
                  filterable
                  style="width:100%"
                  >
                  <el-option
                    v-for="item in idleLeaderList"
                    :key="item.uuid"
                    :label="item.idName"
                    :value="item.uuid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="11">
              <el-form-item label-width="1.2rem" :label="$t('coach1')" prop="chiefCoachUuid">
                <el-select
                  v-model="squadInfo.chiefCoachUuid"
                  :placeholder="$t('coachPlaceholder')"
                  clearable
                  filterable
                  style="width:100%"
                  @change="filterIdleCoach(squadInfo.chiefCoachUuid,-1)"
                  >
                  <el-option
                    v-for="item in idleCoachList"
                    :key="item.uuid"
                    :label="item.idName"
                    :value="item.uuid"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label-width="1.2rem" :label="$t('trainer')">
            <div class="coach_wrap">
              <el-row v-for="(item, index) in coachList" :key="index" class="coachSquad">
                <el-col :span="9">
                  <el-form-item :label="$t('coachName')" label-width=".8rem">
                    <el-select
                      v-model="item.coachUuid"
                      :placeholder="$t('coachPlaceholder')"
                      clearable
                      filterable
                      style="width:100%"
                      @change="filterIdleCoach(item.coachUuid,index)"
                      >
                      <el-option
                        v-for="item in idleCoachList"
                        :key="item.uuid"
                        :label="item.idName"
                        :value="item.uuid"
                        :disabled="item.disabled"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :label="$t('position')">
                    <el-select
                      v-model="item.duty"
                      :placeholder="$t('select')"
                      clearable
                      filterable
                      style="width:100%"
                      >
                      <el-option
                        v-for="item in squadDuty"
                        :key="item.uuid"
                        :label="item.duty"
                        :value="item.duty"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2" :offset="1">
                  <el-button
                    class="addBtn"
                    type="primary"
                    circle
                    icon='el-icon-plus'
                    size="small"
                    @click="addCoach"
                  ></el-button>
                </el-col>
                <el-col v-show='coachList.length>1' :span="2">
                  <el-button
                    class="addBtn"
                    type="danger"
                    circle
                    icon='el-icon-minus'
                    size="small"
                    @click="minusCoach(index)"
                  ></el-button>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
        </el-form>
      </vue-scroll>
    </div>
    <div v-show="!loading" class="btn_wrap">
      <el-button
        type="primary"
        style="margin-right: .3rem"
        :loading="btnLoading"
        @click="addSquad">{{$t('save')}}</el-button>
      <el-button type="danger"  @click="showTip = true">{{$t('cancel')}}</el-button>
    </div>
    <yioks-tip :showTip="showTip" :tipMsg="$t('waivedSubmission')" @callback="isBack"></yioks-tip>
    <yioks-loading v-if="loading"></yioks-loading>
  </SubContent>
</template>

<script>
import { squadNameList } from '@/utils/yioks_data'
import { filterSquadName, filterCode } from '@/utils/yioks_filter'
import squad from '@/api/squad'
import common from '@/api/common'
import squadDuty from '@/api/squadDuty'
import squadFormRule from '@/utils/formRules/squad'
export default {
  components: {
    'SubContent': () => import('@/components/layout/SubContent')
  },
  filters: {
    filterSquadName // 通过球队全称筛选球队简称
  },
  mixins: [squadFormRule],
  data () {
    return {
      squadInfo: { // 表单数据
        squadName: '',
        shortName: '',
        leaderUuid: '',
        chiefCoachUuid: ''
      },
      squadNameList, // 球队名称列表
      coachList: [{ // 助理教练团队的列表
        coachUuid: '',
        duty: '',
        master: false
      }],
      showTip: false, // 退出当前页面提示
      btnLoading: false, // 保存按钮的 loading
      squadUuid: this.$route.query.uuid, // 编辑时，传过来球队的 uuid
      idleCoachList: [], // 空闲教练列表
      idleLeaderList: [], // 空闲领队列表
      squadDuty: [], // 职位列表
      checkCoachList: [], // 被选中的教练，用于 select 选项中禁止
      loading: true,
      dataReady: [false, false, false],
      filterCode
    }
  },
  watch: {
    // 监听球队全称自动填写球队简称
    'squadInfo.squadName': {
      handler (val) {
        this.squadInfo.shortName = filterSquadName(val)
      }
    },
    dataReady (val) {
      if (val.indexOf(false) === -1) this.loading = false
    }
  },
  created () {
    this.getSquadInfo()
    this.getIdleDate()
  },
  methods: {
    // 获取球队信息，用于编辑球队时使用
    getSquadInfo () {
      if (!this.squadUuid) return
      this.dataReady.push(false)
      squad.getSquadInfo(this.squadUuid).then(res => {
        // 将获取的输入填入表单
        let data = res.squad
        this.squadInfo = data
        // 因为教练不能重复添加的规则，编辑时需要手动将获取的所有教练和领队 添加到相应的空闲数组中，以便显示，和修改
        res.coaches.forEach((item, index) => {
          this.idleCoachList.push({
            idName: item.idName,
            uuid: item.uuid
          })
          this.filterIdleCoach(item.coachUuid, index)
        })
        this.idleLeaderList.push({
          idName: data.leaderName,
          uuid: data.leaderUuid
        })
        // 对 coachList 进行处理，如果 coaches 长度为 1 则没有助理教练，不需要进行一下操作
        if (res.coaches.length > 1) {
          // 先清空 coach 的空白模板
          this.coachList = []
          res.coaches.forEach(item => {
            if (item.coachUuid !== data.chiefCoachUuid) {
              this.coachList.push({
                coachUuid: item.coachUuid,
                duty: item.duty,
                master: false
              })
            }
          })
        }

        this.dataReady.splice(3, 1, true)
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    // 获取 select 数据
    getIdleDate () {
      // 添加球队时 data 传 0 编辑球队时，data 传球队的 uuid
      let data = 0
      if (this.squadUuid) data = this.squadUuid
      // 空闲教练
      common.getIdleCoach(data).then(res => {
        this.idleCoachList.push(
          ...res.map(item => {
            item.disabled = false
            return item
          })
        )
        this.dataReady.splice(0, 1, true)
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
      // 空闲教练
      common.getIdleLeader(data).then(res => {
        this.idleLeaderList.push(...res)
        this.dataReady.splice(1, 1, true)
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
      // 教练职位
      squadDuty.getAllDuty().then(res => {
        this.squadDuty = res
        this.dataReady.splice(2, 1, true)
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    goBack (isSure) {
      if (isSure) {
        this.$router.go(-1)
      } else {
        this.showTip = false
      }
    },
    // 添加或编辑球队
    addSquad () {
      this.$refs['squadForm'].validate(valid => {
        if (valid) {
          this.btnLoading = true
          let requestName = squad.addSquad
          let coaches = [...this.coachList]
          coaches.forEach((item, index) => {
            if (!item.coachUuid) coaches.splice(index, 1)
          })
          let requestData = {
            squad: {
              ...this.squadInfo
            },
            coaches
          }
          // 编辑球队时，data 加上 uuid，接口名改变
          if (this.squadUuid) {
            requestName = squad.updataSquad
            requestData.squad.uuid = this.squadUuid
          }
          requestName(requestData).then(res => {
            this.btnLoading = false
            // 重复处理
            if (res.code) {
              if (res.code === 'SquadNameBusy') {
                this.squadNameBusy = true
                this.$refs['squadForm'].validateField('squadName')
              } else if (res.code === 'LeaderBusy') {
                this.LeaderBusy = true
                this.$refs['squadForm'].validateField('leaderUuid')
              } else if (res.code === 'MasterCoachBusy') {
                this.MasterCoachBusy = true
                this.$refs['squadForm'].validateField('chiefCoachUuid')
              } else {
                this.$message.error(this.filterCode(res.code))
              }
            } else {
              this.$router.go(-1)
            }
          }).catch(err => {
            this.btnLoading = false
            console.error(err)
          })
        }
      })
    },
    addCoach () {
      // 助理教练限制，获取多少，只能添加多少。
      // if (this.coachList.length >= this.idleCoachList.length - 1) {
      //   this.$message.error('没有更多的教练可供添加')
      //   return
      // }
      this.coachList.push({
        coachUuid: '',
        duty: '',
        master: false
      })
    },
    minusCoach (index) {
      this.coachList.splice(index, 1)
      this.checkCoachList.splice(index + 1, 1)
      this.filterIdleCoach()
    },
    // 筛选可用的教练 思路：每项选择教练的数据存入相应的 数组坐标中，在通过 indexOf 判断是否禁止 option
    filterIdleCoach (val, index) {
      if (index !== undefined) this.checkCoachList[index + 1] = val
      this.idleCoachList.map((item) => {
        if (this.checkCoachList.indexOf(item.uuid) !== -1) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      })
    },
    isBack (val) {
      if (val) {
        this.showTip = false
        this.$router.go(-1)
      } else {
        this.showTip = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .form_wrap
    height 4.9rem
    padding .3rem 0 0 .1rem
    box-sizing border-box
    .coach_wrap
      padding .2rem
      border 1px solid #FFF
      margin-right .2rem
      .coach_item
        display flex
    .el-row
      margin-bottom .1rem
      &:last-child
        margin-bottom 0
    .coachSquad
      margin-bottom .2rem
      &:last-child
        margin-bottom 0
  .btn_wrap
    display flex
    justify-content center
    padding .2rem 0 .4rem
</style>
